import { EventEmitter, Injectable } from '@angular/core';
import * as _monaco from 'monaco-editor';

@Injectable()
export class MonacoEditorService {
  contentChanged = new EventEmitter<string>();

  private initialContent: string | undefined;
  private currentContent: string | undefined;
  private editor: _monaco.editor.IStandaloneCodeEditor;

  setEditor(editor: _monaco.editor.IStandaloneCodeEditor): void {
    if (this.editor === undefined || this.editor === null) {
      this.editor = editor;
    }
  }

  getEditor(): _monaco.editor.IStandaloneCodeEditor {
    return this.editor;
  }

  setContent(content: string): void {
    this.initialContent = content;
    this.currentContent = content;
    this.contentChanged.emit(content);
  }

  getInitialContent(): string {
    return this.initialContent;
  }

  setInitialContent(content: string | undefined): void {
    this.initialContent = content;
  }

  getCurrentContent(): string {
    return this.currentContent;
  }

  setCurrentContent(content: string | undefined): void {
    this.currentContent = content;
  }

  isEdited(): boolean {
    if (this.initialContent === undefined) {
      return false;
    }
    if (this.currentContent === undefined) {
      return false;
    }
    return this.initialContent !== this.currentContent;
  }

  resetContent(): void {
    this.currentContent = this.initialContent;
  }
}
